import { ExclamationCircleOutlined } from '@ant-design/icons'
import React from 'react'
import styled from 'styled-components'

const ErrorBannerBg = styled.div`
  background-color: red;
  margin-left: -120px;
  /* margin-right: -120px; */
  padding: 1em;
  display: flex;
  align-items: center;

  .anticon {
    font-size: 2em;
    margin-right: 1em;
    margin-left: 1em;
  }

  p {
    color: #fff;
    white-space: break-spaces;
  }

  @media screen and (max-width: 1350px) {
    margin-left: -10px;
    margin-right: -10px;
  }
`

export const ErrorBanner: React.FC = (props) => {
  return (
    <ErrorBannerBg>
      <ExclamationCircleOutlined />
      <p>{props.children}</p>
    </ErrorBannerBg>
  )
}
